export const STORE_CSID = "1ce87aabb042e5f87268c0a7c9001f8f";
export const STORE_CSP = "2621568a3029d211aaf57d24f9db2509";
export const STORE_HardReleaseVersion = "6a59ca3a35c3f6c1baafd89e8085783e";
export const STORE_NIC = "494a31847dda8e76719db78072875783";
export const STORE_ZoneId = "3a62c2eca6d0226d6d7cae0e4dc9be45";
export const STORE_Division_details = "d28b477325076e2a1f24e6fc03a75a82";
export const STORE_ZoneDescription = "97ec6402fb9e2394d9fb1ce92c106086";
export const STORE_DeliveryZoneID = "533478c6b135b32efc301906ea244853";
export const STORE_MTYPE = "4b42cec97c606e73c9ec2c82bcf68b75";
export const STORE_dtoMobileSettings = "39383134c6e166229d3193a599c8865e";
export const STORE_DineType = "4c99e673d479832170469baace792786";
export const STORE_PhoneNo = "12da7df45282106bfe346cbe57931b11";
export const STORE_SelectedMerchant = "31119d2a8ab4dbaf0a0bb34b6ea907c4";
export const STORE_SelectedMerchantProduct = "e97cf31acabedb238b924e0d013369d2";
export const STORE_MobileAppCategory = "9664ac67182982662a0d5eee5148088d";
export const STORE_CustomerName = "143f5ef8368a5cb6f1f9f2724fb707d6";
export const STORE_dtoCustomerAddressList = "d9da3ca5ed68ff5bab63d132bd115b39";
export const STORE_CustomerDefaultAddress = "d298ea30d4fa0b387a7ca829c6ff1c46";
export const STORE_PUSHTOKEN = "c4081063bd743c3f68ec4d7fa5ef79de";
export const STORE_DeviceInfo = "98966b4bf938b0dcbfd90d557dee8263";
export const STORE_MobileCordinates = "26998acfb8fda56f0f69fdb9c81155a1";
export const STORE_StartingNo = "7c3b056b746b8838ba2dd3353057eb39";
export const STORE_PAGE_URL = "9a4963d550e635f92c40152f2b9a31d7";
export const STORE_ISFORCE_TO_SIGN_OUT = "8e10421e349a8395b13c537c1e05f873";

//////////T EMP CUSTOMER /////////////////////////////////////
export const TEMP_STORE_CSID = "012c10f523578ef26d6f2d49252c5cd9";
export const TEMP_STORE_PhoneNo = "aa7fd928c06b708716698ad5b3d7f6a5";
export const TEMP_STORE_CustomerName = "962c1cb82e8830bbba6e1f1d90c8427a";
export const TEMP_STORE_OTP = "d64e4d1bdde08ee8ff77ec6a02efb7a7";

////////////// CART /////////////////////////////
export const STORE_Cart = "f96a5673c06a01b56fb9d261a1fef730";
export const STORE_CartCheckoutData = "f47c74c936748ad8e80f7eaf936e001d";
export const STORE_Addons = "187a6db634123a84ff1177eb7ee2fdf7";
export const STORE_FinaleSelelctCartMerchantNZone = "98e79846a7b486da11a74d28aad2e1fe";
export const STORE_PROMOTIONS = "7cbb78f5555f675b2338d73433879518";
export const STORE_SHEDULEDateNTime = "bf3880c5cef6afb4299e91eecd01715a";

//////////////////// MERCHANT ///////////////////////
export const STORE_MERCHANT = "e3deb17ce9203c8dff84e21f8ef3a275";
export const STORE_PRODUCT_LIST = "a4e15c7d8b37fddffed4db4955ed8bd8";
export const STORE_PROMO_PRODUCT_LIST = "apro4e15c7DDSEd8b37fddffed4db4955ed8bd8";
export const STORE_RATING_POSID = "a4e15c75555f675b23d261a1fef7307G";
export const STORE_PROMO_DATA = "aDC845dcfgvhb5hb675b23d261a1fef7307G";
export const STORE_MERCHANT_SCROLL = "aDC895HYG84fd7v45G858f85895GVGFFfjn07G";
export const STORE_FAVOURITE_MERCHANT_LIST = "c4081063bd98acfb8fdaf84e2136748ad8e";
export const PUSHNOTIFICATIONURL = "fcgvhbjnfhjnmtguhkjntgdujeg897654egthbjnerghjr";

/////////////////// DT ENTRY ///////////////////
export const SECRET_KEY = "SECRET_KEY";
export const CODE = "CODE";
export const MID = "MID";
export const STORE_AUTO_PLACE_ORDER = "STORE_AUTO_PLACE_ORDER";
export const STORE_AUTO_PLACE_PAYMODE = "STORE_AUTO_PLACE_PAYMODE";
export const STORE_AUTO_PLACE_BANK_GUID = "STORE_AUTO_PLACE_BANK_GUID";
export const ENTRY_MODE = "ENTRY_MODE";
export const TABLE_NO = "TABLE_NO";
export const STORE_INVALID_QR = "STORE_INVALID_QR";
